
import { Component, Vue } from 'vue-property-decorator'

import BacHeaderWithMenue from '@/templates/BacHeaderWithMenue.vue'
import BacBlueButton from '@/components/BacBlueButton.vue'
import BacButton from '@/components/BacButton.vue'

@Component({
  components: {
    BacHeaderWithMenue,
    BacBlueButton,
    BacButton
  }
})
export default class Waiting extends Vue {
  registerStateUrl = localStorage.getItem('registerStateLink')
}
